export function getColumnId(index) {
  return "merge-record-header-".concat(index);
}
export function getRowId(property) {
  return "merge-row-header-".concat(property);
}
export default {
  getColumnId: getColumnId,
  getRowId: getRowId
};